/*
 * optins creates the optins logic.
 *
 * Gewenst situatie:
 * Bij het invullen van een telefoonnr wordt er ook automatisch een optin afgegeven voor de phoneNumberOptin.
 * Bij het vullen van het email adres wordt er automatisch een email optin afgegeven voor de loterij (emailOptin).
 * Als je daarna het vinkje aanvinkt van Mediamarkt dan wordt er ook een optin afgegeven voor de Email optin Partner (emailOptInPartner).
 * phoneNumberOptinPartner = altijd false
 * (De preference1 word weergeven als partneroptin aan staat)
 * https://novamedia-jira.atlassian.net/browse/VLC-3277
 * https://novamedia-jira.atlassian.net/browse/VLC-3276
 *
 * Notes:
 * - here we use attr() instead of prop() for functionality in IE10
 */

const optins = () => {
  if ($('#phone-number-optIn').length === 1 && $('#phone-number-optIn').attr('hidden')) {
    $('#tel').on('change', function handleChange() {
      const checked = $(this).val() !== '';
      $('#phone-number-optIn').attr('checked', checked);
    });
  }

  if ($('#email-optin').length === 1 && $('#email-optin').attr('hidden')) {
    $('#email').on('change', function handleChange() {
      const checked = $(this).val() !== '';
      $('#email-optin').attr('checked', checked);
    });
  }

  if ($('#partner-mail-opt-in').length === 1 && $('#partner-mail-opt-in').attr('hidden')) {
    $('#email').on('change', function handleChange() {
      const checked = $(this).val() !== '';
      $('#partner-mail-opt-in').attr('checked', checked);
    });
  }

  if ($('#preference1').length === 1) {
    $('#preference1').closest('.form-group').hide();
  }

  if ($('#preference1').length === 1 && $('#partner-mail-opt-in').length === 1) {
    const checkPreference = () => {
      const checked = $('#partner-mail-opt-in').attr('checked');
      if (checked) {
        $('#preference1').closest('.form-group').show();
      } else {
        $('#preference1').closest('.form-group').hide();
        $('#preference1').attr('checked', false);
      }
    };
    $('#email-optin').on('change', checkPreference);
    $('#partner-mail-opt-in').on('change', checkPreference);
  }
};

export default optins;
